import { useEffect, useState } from "react";

const currentBreakpoint = () => window.matchMedia("(max-width: 767px)").matches ? "mobile" : window.matchMedia("(max-width: 1099px)").matches ? "tablet" : "desktop";

// No network requests or motion while a scene is off screen or the tab is hidden.
export const useMediaActivity = (ref, eager = false) => {
  const [near, setNear] = useState(eager);
  const [visible, setVisible] = useState(false);
  const [foreground, setForeground] = useState(!document.hidden);
  const [breakpoint, setBreakpoint] = useState(currentBreakpoint);
  const mobile = breakpoint === "mobile";
  const [saveData, setSaveData] = useState(() => Boolean(navigator.connection?.saveData));
  useEffect(() => {
    const query = window.matchMedia("(max-width: 767px)");
    const tablet = window.matchMedia("(max-width: 1099px)");
    const resize = () => setBreakpoint(currentBreakpoint());
    const visibility = () => setForeground(!document.hidden);
    const connection = () => setSaveData(Boolean(navigator.connection?.saveData));
    const warm = new IntersectionObserver(([entry]) => { if (entry.isIntersecting) setNear(true); }, { rootMargin: "200px" });
    const active = new IntersectionObserver(([entry]) => setVisible(entry.isIntersecting), { threshold: 0.05 });
    warm.observe(ref.current);
    active.observe(ref.current);
    query.addEventListener("change", resize);
    tablet.addEventListener("change", resize);
    document.addEventListener("visibilitychange", visibility);
    navigator.connection?.addEventListener("change", connection);
    return () => {
      warm.disconnect(); active.disconnect();
      query.removeEventListener("change", resize);
      tablet.removeEventListener("change", resize);
      document.removeEventListener("visibilitychange", visibility);
      navigator.connection?.removeEventListener("change", connection);
    };
  }, [ref]);
  return { near, visible, foreground, mobile, saveData, breakpoint };
};